module.exports = __webpack_public_path__ + "static/media/balance.57837728.svg";